// @generated by protoc-gen-connect-query v2.1.1 with parameter "target=ts"
// @generated from file bff/v1/common.proto (package bff.v1, syntax proto3)
/* eslint-disable */

import { BffCommonService } from "./common_pb";

/**
 * @generated from rpc bff.v1.BffCommonService.ListProducts
 */
export const listProducts = BffCommonService.method.listProducts;

/**
 * @generated from rpc bff.v1.BffCommonService.GetProductByPlanId
 */
export const getProductByPlanId = BffCommonService.method.getProductByPlanId;

/**
 * @generated from rpc bff.v1.BffCommonService.ListUserRoles
 */
export const listUserRoles = BffCommonService.method.listUserRoles;

/**
 * @generated from rpc bff.v1.BffCommonService.ListSelectableUserRoles
 */
export const listSelectableUserRoles = BffCommonService.method.listSelectableUserRoles;

/**
 * @generated from rpc bff.v1.BffCommonService.GetMemberProfile
 */
export const getMemberProfile = BffCommonService.method.getMemberProfile;

/**
 * @generated from rpc bff.v1.BffCommonService.UpdateOwnMemberProfile
 */
export const updateOwnMemberProfile = BffCommonService.method.updateOwnMemberProfile;

/**
 * @generated from rpc bff.v1.BffCommonService.GetOrganization
 */
export const getOrganization = BffCommonService.method.getOrganization;

/**
 * @generated from rpc bff.v1.BffCommonService.GetPlan
 */
export const getPlan = BffCommonService.method.getPlan;

/**
 * @generated from rpc bff.v1.BffCommonService.ListMembers
 */
export const listMembers = BffCommonService.method.listMembers;

/**
 * @generated from rpc bff.v1.BffCommonService.UploadMemberImage
 */
export const uploadMemberImage = BffCommonService.method.uploadMemberImage;

/**
 * @generated from rpc bff.v1.BffCommonService.GetCompanyAllowedMailDomains
 */
export const getCompanyAllowedMailDomains = BffCommonService.method.getCompanyAllowedMailDomains;

/**
 * @generated from rpc bff.v1.BffCommonService.EmailVerified
 */
export const emailVerified = BffCommonService.method.emailVerified;

/**
 * @generated from rpc bff.v1.BffCommonService.ListSessions
 */
export const listSessions = BffCommonService.method.listSessions;

/**
 * @generated from rpc bff.v1.BffCommonService.FinishSession
 */
export const finishSession = BffCommonService.method.finishSession;
